import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { withAccount } from '../../../components/AccountContext';
import { dispatchGraphqlErrors, dispatchDefaultSuccess } from '../../../utils/NotificationUtil';
import RespondentDetailQuery from './RespondentDetailQuery';
import RespondentDetail from './RespondentDetail';

const mapStateToProps = (state) => {
  const { user } = state.app;
  return {
    user,
  };
};
const mapDispatchToProps = dispatch => ({
  onRequestSuccess: (message) => {
    dispatchDefaultSuccess(dispatch, message);
  },
  onRequestFailed: (errors) => {
    dispatchGraphqlErrors(dispatch, errors);
  },
});

const compositComponent = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(RespondentDetailQuery(RespondentDetail)),
);
export default injectIntl(withAccount(compositComponent));
